import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBoxMaxLine1FontSmBold } from 'atoms/TextBox/Templates'
import { COLOR } from 'vars/color'
import { MenuButtonSC } from './MenuButton.styled'

interface IMenuButtonProps {
  title: string
}

export const MenuButton = ({ title }: IMenuButtonProps) => {
  return (
    <MenuButtonSC>
      <TextBoxMaxLine1FontSmBold>{title}</TextBoxMaxLine1FontSmBold>

      <Icon
        name={IconNames.angleRight}
        size={IconSizes.xSm}
        color={COLOR.TEXT_ICON_PRIMARY}
      />
    </MenuButtonSC>
  )
}
